import React, { useContext } from "react";
import EditModal from "../../profiles/EditModal";
import { PrProfileContext } from "../data/pr_profile_context_management";
import CompaniesModalBody from "./companies_modal_body";
import EmploymentModalBody from "./employment_modal_body";
import ExpertsModalBody from "./experts_modal_body";
import HeaderModalBody from "./header_modal_body";
import ProductsModalBody from "./products_modal_body";

// PR Profile's edit modal: consumes the shared <EditModal> shell (chrome only) and keeps the
// engine-specific section -> body mapping + title here (mirrors companies/edit/edit_modal.jsx).
// The bodies own their own <Modal.Body>/<Modal.Footer> (the shell renders children raw).
function PrProfileEditModal() {
  const { prProfile, openEditModal, setOpenEditModal, setGeneralError } = useContext(PrProfileContext);

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const sectionLabel = () => {
    switch (openEditModal) {
      case "HEADER":
        return " - Header Details";
      case "EMPLOYMENT":
        return " - Employment Details";
      case "EXPERTS":
        return " - Add Represented Expert";
      case "PRODUCTS":
        return " - Add Represented Product";
      case "COMPANIES":
        return " - Add Represented Company";
      default:
        return null;
    }
  };

  const body = () => {
    // All bodies read the loaded profile + their plumbing (prProfileId, silentReload,
    // setGeneralError, ...) from PrProfileContext; they take only `close` as a prop.
    switch (openEditModal) {
      case "HEADER":
        return <HeaderModalBody close={closeModal} />;
      case "EMPLOYMENT":
        return <EmploymentModalBody close={closeModal} />;
      case "EXPERTS":
        return <ExpertsModalBody close={closeModal} />;
      case "PRODUCTS":
        return <ProductsModalBody close={closeModal} />;
      case "COMPANIES":
        return <CompaniesModalBody close={closeModal} />;
      default:
        return null;
    }
  };

  return (
    <EditModal
      show={!!openEditModal}
      onClose={closeModal}
      fullscreen="lg-down"
      title={
        <>
          Editing {prProfile?.name}
          {sectionLabel()}
        </>
      }
    >
      {body()}
    </EditModal>
  );
}

export default PrProfileEditModal;
